<template>
    <div class="container-all overflow-auto">

        <v-container class="d-flex align-center justify-center container-main mb-15">

            <v-card class="rounded-xl" width='400'>

                <v-card-text class="d-flex align-center justify-center">
                    <v-img class="logo" max-width="200" max-height="200" alt="logo" src="../../../assets/logo-lateral.png"> 
                  
                 </v-img>
                </v-card-text>

                <v-card-text class="my-10">
                    <v-row class="d-flex flex-column mx-1">
                        <v-col>
                            <p class="label-register font-weight-light title text-center">
                                {{ $t('provider_login.do_login') }}
                            </p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="mb-10">
                    <v-row class="d-flex flex-column mx-1">

                        <v-col>

                            <v-form v-model="valid" class="d-flex flex-column form-login">

                                <v-text-field type="text" outlined class="register-field email-field" v-model="email" @keyup.enter="onLoginClick()" :rules="emailRules" :disabled="loading" :label="$t('fields.email.label')" :placeholder="$t('fields.username.placeholder')">
                                </v-text-field>

                                <v-text-field outlined class="register-field password-field" v-model="password" @keyup.enter="onLoginClick()" @click:append="showPassword = !showPassword" :rules="passwordRules" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" :disabled="loading" :label="$t('fields.password.label')" :placeholder="$t('fields.password.placeholder')">
                                </v-text-field>

                                <div class="forgot_password mt-n8 ml-auto mb-5">
                                    <v-btn text class="forgot-password-link caption text-none" @click="forgotPassword()">
                                        {{ $t('forgot_password') }}
                                    </v-btn>
                                </div>

                                <v-btn color="#4ec5c1" rounded class="btn-connect"  :loading="loading" :disabled="loading || !valid" @click="onLoginClick()"> {{ $t('account_login.connect') }}
                                </v-btn>
                            </v-form>

                        </v-col>

                        <v-col v-if="!loginClick">
                            <v-btn @click="onRegisterClick" class="btn-register"  rounded color='#4ec5c1' block>{{ $t('account_login.register') }}</v-btn>
                        </v-col>
                    </v-row>

                </v-card-actions>

            </v-card>

        </v-container>

        <v-dialog v-model="dialog" persistent max-width="400">
            <v-card>
                <v-app-bar color="primary" dense dark>
                    <v-toolbar-title>{{ $t('info_username') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon text @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-alert dense type="info">{{ $t('recover_msg') }}</v-alert>
                <v-card-text>
                    <v-form @submit.prevent="" v-model="validRecover">
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" md="12" class="d-flex">
                                    <v-text-field type="email" id="recover1" outlined class="email-recover-field" v-model="emailRec" :rules="emailRules" :disabled="loading" :label="$t('fields.email.label')" :placeholder="$t('fields.email.placeholder')">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex flex-column justify-center align-center btn-recover-password">
                                    <v-btn @click="recover" :disabled='!validRecover' type='submit' color="primary">{{ $t('send') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex'
    import {LOGIN, SET_PROVIDER, MAIL_RECOVER} from "@/store/mutations"
	import { ROUTER_REGISTER_ACCOUNT } from '../../../router/routes'
    import validators from '../../../utils/validators'
    import { LOGOUT, SET_AREAS, SET_USER } from '../../../store/mutations'

	export default {
		name: 'HomeAccount',
		data() {

			return {
                loginClick: false,
				email: null,
                emailRec: null,
				password: null,
				valid: false,
                showPassword: false,
                dialog: false,
                loading: false,
                validRecover: false,
				emailRules: [
					v => validators.email.required(v) || this.$t('validators.email.required'),
					v => validators.email.invalid(v) || this.$t('validators.email.invalid'),
				],
				passwordRules: [
					v => validators.password.required(v) || this.$t('validators.password.required'),
				],
			};
        },
        
        mounted() {

            this.setProvider({})
            this.setUser({})
            this.setAreas([])

        },

		methods: {

            ...mapActions({login: `UserVuex/${LOGIN}`, emailRecover: `UserVuex/${MAIL_RECOVER}`, logoutMe: `UserVuex/${LOGOUT}`}),

            ...mapMutations({setProvider: `ProviderVuex/${SET_PROVIDER}`, setAreas: `AreaVuex/${SET_AREAS}`, setUser: `UserVuex/${SET_USER}`}),

			async onLoginClick() {

                this.loading = true;

                const login = await this.login({ email: this.email, password: this.password }); 
                
                if (!login) {

                    this.showToast(this.$t('provider_login.toast_error_msg'), this.$t('provider_login.toast_error_title'), 'error')  
                                      
                    return this.loading = false;

                }

                this.email = null;

                this.password = null;
                
                this.loading = false;
                
            },

            onRegisterClick() {
                this.$router.push(ROUTER_REGISTER_ACCOUNT);
            },

			forgotPassword() {

                this.dialog = true;
                
            },

			async recover() {

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

                this.loading = true;

                try {

                    await this.emailRecover({email: this.emailRec, locale: localStorage.getItem('locale')});

                    this.dialog = false
                    this.emailRec = null;

                    return this.$toast.success(this.$t('provider_login.toast_recover_msg'), this.$t('provider_login.toast_recover_title'), {
                        position: "center",
                       
                    });
                    
                } catch (error) {

                    console.log(error);

                    return this.$toast.error(this.$t('provider_login.toast_error_recover_msg'), this.$t('provider_login.toast_error_recover_title'), {
                        position: "center",
                       
                    });
                    
                } finally {

                    this.loading = false;
                    loader.hide();
                    

                }
            },          
		},
	};
</script>

<style scoped>

.container-all {
    width: 100%;
    height: 100%;
    overflow-y: auto;

}

.forgot-password-link {
 
    color: #06a6e6;

}

.logo {



}

@media all and (min-width: 700px) {
    .container-main {

        margin-top: 3%;


    }

    .container-all {
        width: 100%;
        height: 100%;
        overflow-y: hidden;

    }
}

</style>
